// extracted by mini-css-extract-plugin
export default {"innerWrapper":"rA-z","tooltipWrapper":"sA-z","icon":"tA-z","tooltip":"uA-z","content":"vA-z"};